import { render } from "./modelContent.vue?vue&type=template&id=15c5aae2&scoped=true"
import script from "./modelContent.vue?vue&type=script&lang=js"
export * from "./modelContent.vue?vue&type=script&lang=js"

import "./modelContent.vue?vue&type=style&index=0&id=15c5aae2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15c5aae2"]])

export default __exports__